<template>	   
	<material-card
	  class="card-tabs"
	  color="success"
		title="Crear nueo item de menu"
	  text="Agrega un nuevo item al menu"
	  >
	  	<v-card>
				<v-card-text>
				  <v-layout row justify-center>
						<v-flex xs10 offset-xs1>
							<v-form ref="menu" v-model="validMenu">  
								<v-text-field 
									required 
									:error="storeMErrors['name']" :error-messages="storeMErrors['name']"
									:rules="nameRules"
								  name="name" solo
								  label="Nombre del item"
								  id="id"
								  v-model="item.name"
								></v-text-field>
								<v-text-field 
									required 
									:error="storeMErrors['link']" :error-messages="storeMErrors['link']"
									:rules="linkRules"
								  name="link" solo
								  label="Url to:"
								  id="link"
								  v-model="item.link"
								></v-text-field>
								<v-text-field 
									required 
									:error="storeMErrors['icon']" :error-messages="storeMErrors['icon']"
									:rules="iconRules"
								  name="icon" solo
								  label="Icono de menu"
								  id="icon" :append-icon="item.icon"
								  v-model="item.icon"
								></v-text-field>
								<v-text-field 
									required 
									:error="storeMErrors['text']" :error-messages="storeMErrors['text']"
									:rules="textRules"
								  name="text" solo
								  label="Texto del menu"
								  id="text"
								  v-model="item.text"
								></v-text-field>	
								<v-select 
									:items="roles"
									item-text="text" item-value="value"
									required
									multiple 
									:error="storeMErrors['habilited']" :error-messages="storeMErrors['habilited']"
									:rules="textRules"
								  name="habilited" solo
								  label="Visible para"
								  id="habilited"
								  v-model="item.habilited"
								></v-select>	
								<v-layout row wrap>
								  <v-flex xs6>
										<v-checkbox label="Submenu" @change="activeSubmenu()" v-model="item.submenu"></v-checkbox>
								  </v-flex>
								  <v-flex xs6>  
								  	<v-spacer></v-spacer>
										<v-btn left  v-if="item.submenu" fab small color="success" @click="addSubmenu" long class="text-md-center"><v-icon>fas fa-plus</v-icon></v-btn>
								  </v-flex>
								</v-layout>
							</v-form>
						</v-flex>
				  </v-layout>
				  <v-divider></v-divider>
				  <v-layout row wrap justify-center>
					    <v-flex xs12 shrink>
				  	<v-scale-transition>	
				  		<div v-show="item.submenu">
								<v-layout row :wrap="itemsSubmenu.length > 3" justify-center>								
									<v-flex :xs5="itemsSubmenu <= 3" :xs4="itemsSubmenu > 3"  v-for="(submenu, key) in itemsSubmenu" :key="key">
										<v-card>
											<v-card-title primary-title>
												Sub item
											  <v-spacer></v-spacer>
											  <v-icon @click="deleteItem(key)">fas fa-times</v-icon>
											</v-card-title>
											<v-card-text>			
												<v-form :ref="'submenu' + key" v-model="validSubMenu">					      
													<v-text-field 
														required 

														:rules="nameRules"
													  name="name" solo
													  label="Nombre del sub item"
													  v-model="submenu.name"
													></v-text-field>
													<v-text-field 
														required 

														:rules="linkRules"
													  name="link" solo
													  label="Url to:"
													  v-model="submenu.link"
													></v-text-field>
													<v-text-field 
														required 

														:rules="iconRules"
													  name="icon" solo
													  label="Icono de menu"
														:append-icon="submenu.icon"
													  v-model="submenu.icon"
													></v-text-field>
													<v-text-field 
														required 

														:rules="textRules"
													  name="text" solo
													  label="Texto del menu"
													  v-model="submenu.text"
													></v-text-field>		
												</v-form>						    
											</v-card-text>  
										</v-card>
										<v-divider></v-divider>    
									</v-flex>	  
								</v-layout>	
				  		</div>
				  	</v-scale-transition>
							</v-flex xs12>
				  </v-layout>	
				</v-card-text>
				<v-card-actions>
				  <v-btn color="success" @click="store()">Guardar</v-btn>
				</v-card-actions>
	  	</v-card>
	</material-card>
</template>
<script>
	export default{
		created() {

		},
		mounted(){

		},
		props: [
			 
		],
		data(){
			return {
				baseRoute: process.env.VUE_APP_URL + 'api/menu',
				storeMErrors: [],
				storeSErrors: [],
				validMenu: false,
				validSubMenu: false,
				roles: [
					{text: 'Administrador', value: 1},
					{text: 'Usuario', value: 2},
					{text: 'Visualizador', value: 3},
				],
				item: {
					name: '',
					link: '',
					icon: '',
					text: '',
					habilited: [],
					submenu: false
				},
				nameRules: [
					(v) => !!v || 'El nombre es obligatorio',
				],
				iconRules: [
					(v) => !!v || 'El icono es obligatorio'
				],
				textRules: [
					(v) => !!v || 'El texto es obligatorio es obligatorio'
				],
				linkRules: [
					(v) => !!v || 'El link de redireccion es obligatorio es obligatorio'
				],
				itemsSubmenu: []
			}
		},
		methods: {
			activeSubmenu(){
				if(this.item.submenu){
					this.itemsSubmenu.push({
						name: '',
						link: '',
						icon: '',
						text: '',
					})
				}else{
					this.itemsSubmenu = []
				}
			},
			addSubmenu(){
				this.itemsSubmenu.push({
						name: '',
						link: '',
						icon: '',
						text: '',
					})
			},
			store(){
				let formData = {
					menu: this.item,
					submenu_items: this.itemsSubmenu
				}
				if(this.$refs.menu.validate()){
					axios.post(this.baseRoute + '/store', formData).then((res) => {
						this.$router.push('/admin/menu');
					}); 
					
				}
			},
			deleteItem(key)
			{
				this.itemsSubmenu.splice(key, 1);
			}
		},
		watch: {	

		},
		computed: {

		},
	}
</script>